"use strict";
var drawTemplate = require("../templates/draw.handlebars");
var ladderTemplate = require("../templates/ladder.handlebars");
var mainTemplate = require("../templates/mainForm.handlebars");
var restAPI = require('../restAPI.ts');
var seasons, indexData, compData;
$("#mainContainer").on('visible', function () {
    $("#mainContainer").on('click', onClick);
    restAPI.getIndex().then(function (data) {
        refresh(data);
    });
});
$("#mainContainer").on('hidden', function () {
    $("#mainWrapper").html("");
    $("#mainContainer").off('click');
});
function refresh(data) {
    console.log("data: " + JSON.stringify(data));
    indexData = data;
    seasons = _.map(data, 'season');
    var html = mainTemplate({ seasons: seasons });
    $("#mainWrapper").html(html);
    $('.selectpicker')["selectpicker"]();
    $("#seasonCB").on("change", updateGradesSelection);
    $("#gradeCB").on("change", compSelected);
    updateGradesSelection();
}
function refreshDraw(comp) {
    compData = comp;
    var html = drawTemplate({ games: comp.games });
    $("#draw").html(html);
    var html = ladderTemplate({ ladder: comp.getLadder() });
    $("#ladder").html(html);
}
function compSelected() {
    var val = $("#gradeCB").val();
    if (val === undefined || val === null)
        return;
    restAPI.getComp(parseInt(val, 10)).then(function (data) {
        refreshDraw(data);
    });
}
function updateGradesSelection() {
    var seasonCB = $("#seasonCB"), seasonVal = seasonCB.val(), gradeCB = $("#gradeCB");
    gradeCB.empty();
    if (seasonVal === undefined || seasonVal === null) {
        gradeCB.prop("disabled", true);
        return;
    }
    gradeCB.prop("disabled", false);
    var filteredGrades = _.filter(indexData, { season: seasonVal });
    _.forEach(filteredGrades, function (comps) {
        gradeCB.append('<option value="' + comps["id"] + '">' + comps["grade"] + '</option>');
    });
    if (filteredGrades.length === 1)
        compSelected();
}
function onClick(e) {
    if (e.target === undefined)
        return;
    if (e.target["id"] === undefined)
        return;
    var id = e.target["id"];
    switch (id) {
        case "bbStartGame":
            onStartGameClick(e.target);
    }
}
function onStartGameClick(button) {
    var gameId = $(button).data("gamenumber");
    if (restAPI.hasDutyAuth() === true)
        $.bbq.pushState({ tab: "duty", comp: compData.id, game: gameId });
    else {
        restAPI.showDutyLogin().then(function () {
            $.bbq.pushState({ tab: "duty", comp: compData.id, game: gameId });
        });
    }
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/forms/mainForm.ts
 ** module id = 32
 ** module chunks = 1
 **/